import axios from 'axios';
import debug from '../utils/debug';

const apiDebug = debug.module('Axios');

// Log initialization
apiDebug.log('Initializing axios instance');
apiDebug.log('VITE_API_URL:', import.meta.env.VITE_API_URL || '(empty - using relative URLs)');

// Create axios instance
// Use VITE_API_URL if set (Local Dev), otherwise empty (Production Nginx Proxy)
const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || ''
});

apiDebug.log('Axios instance created with baseURL:', api.defaults.baseURL || '(empty)');

// Request interceptor to add auth token and debug logging
api.interceptors.request.use(
    (config) => {
        // Debug logging
        debug.api.request(config);

        // Add auth token if available
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        debug.api.error(error);
        return Promise.reject(error);
    }
);

// Response interceptor for debug logging
api.interceptors.response.use(
    (response) => {
        debug.api.response(response);
        return response;
    },
    (error) => {
        debug.api.error(error);
        return Promise.reject(error);
    }
);

export default api;
